<script setup>
import {computed, onMounted, ref, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CorporationMatchingStateView from "../../../../pages/admin/views/corporation/detail/CorporationMatchingStateView.vue";
import CorporationMatchingApplyStateView from "../../../../pages/admin/views/corporation/detail/CorporationMatchingApplyStateView.vue";

const route = useRoute();
const router = useRouter();
const loaded = ref(false);
const tabRef = ref(null);

const props = defineProps({
  corporation: {
    type: Object,
    default: () => ({}),
  },
});

const corporation = computed(() => props.corporation || {});

const tabOptions = [
  { label: '채용제안 현황', value: 'matching-state' },
  { label: '입사지원 현황', value: 'matching-applyState' },
];

const getTabValue = (tab) => {
  return tabOptions.some(option => option.value === tab) ? tab : tabOptions[0].value;
}

const selectedTabValue = ref(getTabValue(route.query.subTab));

const onChangeTab = (tab) => {
  if (selectedTabValue.value === tab.value) {
    return;
  }

  router.push({ query: { ...route.query, subTab: tab.value } });
};

onMounted(() => {
  if (tabRef.value) {
    tabRef.value.init(selectedTabValue.value);
  }
});

watch(
    () => route.query.subTab,
    (tab) => {
      const nextTabValue = getTabValue(tab);
      selectedTabValue.value = nextTabValue;

      if(tabRef.value) {
        tabRef.value.init(nextTabValue);
      }
    },
    { immediate: true }
);
</script>

<template>
  <div>
    <div class="tab-wrap mb-sm">
      <KSATab
          ref="tabRef"
          :options="tabOptions"
          @change="onChangeTab"
          style="grid-template-columns: repeat(2, 1fr);"
      />
    </div>
    <div v-if="selectedTabValue === 'matching-state'">
      <CorporationMatchingStateView :corporation="corporation" />
    </div>
    <div v-else-if="selectedTabValue === 'matching-applyState'">
      <CorporationMatchingApplyStateView :corporation="corporation" />
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
</style>
